// Category configuration controls presentation, never which source rows exist.
export function distributionDetailGroups(config, add, sub) {
  return config.map(group => {
    const values = group.num === 2 ? add : sub;
    const keys = Object.keys(values).filter(key => values[key] !== '' && values[key] != null);
    return { ...group, list: [...group.list.filter(key => keys.includes(key)),
      ...keys.filter(key => !group.list.includes(key))] };
  });
}

export function distributionDetailStyle(config, key) {
  return config[key] || { name: '其他调整', color: '#8b9bad' };
}

// Empty disclosure cells must never become Number('') === 0.
export function distributionAmount(value) {
  if (value == null || typeof value === 'boolean' || String(value).trim() === '') return NaN;
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : NaN;
}

export function distributionPeriod(snapshot, period) {
  return Object.fromEntries((snapshot?.ori_ || []).map(row => [row.factory_name, row[period]]));
}

export function distributionAdjustments(rows, period) {
  const result = {};
  for (const row of rows || []) {
    if (!Object.prototype.hasOwnProperty.call(row, period) || row[period] === '' || row[period] == null) continue;
    // Multiple legitimate rows may share a display name. Do not overwrite one.
    const value = distributionAmount(row[period]);
    result[row.factory_name] = Object.prototype.hasOwnProperty.call(result, row.factory_name)
      ? result[row.factory_name] + value : value;
  }
  return result;
}

export function distributionNotice(summary, adds, subs, period, detail = false) {
  const labels = ['EBITDA', '调增项', '调减项', '可分派金额'];
  const values = labels.map(key => distributionAmount(summary[key]));
  const missing = labels.filter((_, i) => !Number.isFinite(values[i]));
  if (missing.length) return `缺少${missing.join('、')}，缺值不按零绘制`;
  const [start, add, sub, end] = values;
  const messages = [];
  const gap = start + add + sub - end;
  if (Math.abs(gap) > 0.01) messages.push(`汇总与可分派金额差额 ${(gap / 10000).toFixed(2)} 万元`);
  if (detail) {
    for (const [label, rows, total] of [['调增', adds, add], ['调减', subs, sub]]) {
      const vals = (rows || []).filter(row => row[period] !== '' && row[period] != null)
        .map(row => distributionAmount(row[period]));
      if (vals.some(value => !Number.isFinite(value)) || Math.abs(vals.reduce((a,b) => a+b, 0) - total) > 0.01)
        messages.push(`${label}明细与汇总未对齐`);
    }
  }
  return messages.join('；');
}

export function formatDistributionRow(row) {
  const key = row[0];
  const kind = key === 'DPU' ? 'unit' : key === 'Div Yield(报告期)' ? 'percent' : 'amount';
  const unit = kind === 'unit' ? '元' : kind === 'percent' ? '%' : '万元';
  return [`${key}（${unit}）`, ...row.slice(1).map(value => {
    const amount = distributionAmount(value);
    if (!Number.isFinite(amount)) return '';
    if (amount === 0) return 0;
    if (kind === 'unit') return amount.toFixed(4);
    if (kind === 'percent') return (amount * 100).toFixed(2) + '%';
    return Number((amount / 10000).toFixed(1)).toLocaleString();
  })];
}

// Position a disclosed final bridge component from its reported endpoint when
// an earlier component is absent. This never imputes the absent component.
export function distributionBridgeStart(previous, endpoint, adjustment) {
  if (Number.isFinite(previous)) return previous;
  const end = distributionAmount(endpoint);
  const amount = distributionAmount(adjustment);
  return Number.isFinite(end) && Number.isFinite(amount) ? end - amount : NaN;
}
